import { EmployeeRole } from '@/common/graphql';
import { EmployeeRoleLabels } from '@/common/types';
import { ObjectUtils } from '@/common/utils';

import type { ComboboxItemWithFormatted } from '../props';
import { SelectMultiple, type SelectMultipleProps } from '../SelectMultiple';

interface EmployeeRoleSelectMultipleProps
  extends Omit<SelectMultipleProps<ComboboxItemWithFormatted<EmployeeRole>>, 'searchable' | 'value'> {
  value: Array<EmployeeRole> | null | undefined;
}

const data = ObjectUtils.arrayFromEnumValues<EmployeeRole>(EmployeeRole).map(value => ({
  label: EmployeeRoleLabels[value],
  value,
}));

export const EmployeeRoleSelectMultiple = ({
  placeholder = 'Select role',
  ...rest
}: EmployeeRoleSelectMultipleProps) => (
  <SelectMultiple
    {...rest}
    data={data}
    loading={false}
    multipleSelectedLabel={length => `${length} roles`}
    placeholder={placeholder}
    searchable={false}
  />
);
